<template>
  <div :class="{'scenario-container': !isMenuMiniSize, 'scenario-container-thin-menu': isMenuMiniSize}">
    <EmploymentPageList   v-if="$route.path === '/dashboard/employment/list' || $route.path === '/client/employment/list'"/>
    <EmploymentPageEditor v-if="$route.path.indexOf('/dashboard/employment/editor') >= 0 || $route.path.indexOf('/client/employment/editor') >= 0" />
    <EmploymentTemplate   v-if="$route.path === '/dashboard/employment/template' || $route.path === '/client/employment/template'"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EmploymentPageList from '@/views/DashBoard/EmploymentPage/EmploymentPageList'
import EmploymentPageEditor from '@/views/DashBoard/EmploymentPage/EmploymentPageEditor'
import EmploymentTemplate from '@/views/DashBoard/EmploymentPage/EmploymentTemplate'
export default {
  name: 'EmploymentPage',
  componentName: 'EmploymentPage',
  components: {
    EmploymentPageList,
    EmploymentPageEditor,
    EmploymentTemplate
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('employmentPage', ['pageList']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  created () {
    this.$store.dispatch('employmentPage/getRootContent')
    // 作成済みの求人原稿タグ取得
    this.$store.dispatch('employmentPage/getEmploymentPageTag')
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  watch: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.scenario-container {
  height: 100vh;
  width: calc(100vw - 205px);
  display: flex;
  justify-content: left;
}
.scenario-container-thin-menu {
  height: 100vh;
  width: calc(100vw - 55px);
  display: flex;
  justify-content: left;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/EmploymentPage/EmploymentPage.vue